import LoadingLogo from '../Loading';

const RouteFallback = () => <LoadingLogo />;

export default RouteFallback;
